import React, {Component} from "react";

export default class ConnectBankAccount extends Component {
    constructor(props) {
        super(props);

        this.state = {
            connectBankAccount_companyBankAccount: props.data.connectBankAccount_companyBankAccount,
            stepAt: props.data.stepAt,
        };

        this._validateOnDemand = true; // this flag enables onBlur validation as user fills forms

        this.validationCheck = this.validationCheck.bind(this);
        this.isValidated     = this.isValidated.bind(this);
    }

    isValidated() {
        const userInput        = this._grabUserInput(); // grab user entered vals
        const validateNewInput = this._validateData(userInput); // run the new input against the validator
        let isDataValid        = false;

        // if full validation passes then save to store and pass as valid
        if(
            Object.keys(validateNewInput).every((k) => {
                return validateNewInput[k] === true;
            })
        ) {
            if(
                this.props.data.connectBankAccount_companyBankAccount !== userInput.connectBankAccount_companyBankAccount
            ) {// only update store of something changed
                this.props.onNext({
                    ...userInput, // use this to notify step4 that some changes took place and prompt the user to save again
                    stepAt: this.props.data.stepAt,
                }); // Update store here (this is just an example, in reality you will do it via redux or flux)
            }

            isDataValid = true;
        } else {
            // if anything fails then update the UI validation state but NOT the UI Data State
            this.setState(
                Object.assign(
                    userInput,
                    validateNewInput,
                    this._validationErrors(validateNewInput)
                )
            );
        }

        return isDataValid;
    }

    validationCheck() {
        if(!this._validateOnDemand) return;

        const userInput        = this._grabUserInput(); // grab user entered vals
        const validateNewInput = this._validateData(userInput); // run the new input against the validator

        this.setState(
            Object.assign(
                userInput,
                validateNewInput,
                this._validationErrors(validateNewInput)
            )
        );
    }

    _validateData(data) {
        return {
            connectBankAccount_companyBankAccountVal: data.connectBankAccount_companyBankAccount !== "",
        };
    }

    _validationErrors(val) {
        const errMsgs = {
            connectBankAccount_companyBankAccountValMsg: val.connectBankAccount_companyBankAccountVal
                ? ""
                : "Bank Account is required",
        };
        return errMsgs;
    }

    _grabUserInput() {
        return {
            connectBankAccount_companyBankAccount: this.connectBankAccount_companyBankAccount.value,
        };
    }

    render() {
        // explicit class assigning based on validation
        let notValidClasses = {};

        if(
            typeof this.state.connectBankAccount_companyBankAccountVal === "undefined" ||
            this.state.connectBankAccount_companyBankAccountVal
        ) {
            notValidClasses.connectBankAccount_companyBankAccountCls = "form-control";
        } else {
            notValidClasses.connectBankAccount_companyBankAccountCls       = "is-invalid form-control";
            notValidClasses.connectBankAccount_companyBankAccountValGrpCls = "text-danger";
        }

        return (
            <div className="step step1 mt-5 ">
                <div className="row justify-content-md-center">
                    <div className="col col-lg-6">
                        <div className="">
                            <h4>Setup Your Bank Account</h4>
                            {/* <h6 className="card-subtitle">
                            To comply with regulation we collect this information to confirm
                            that you are a business that is legally incorporated.
                          </h6> */}
                            <form id="Form" className="form-horizontal mt-5">
                                <div className="row">
                                    <div className="form-group content form-block-holder col-sm-12 col-lg-6 col-md-6">
                                        <label className="control-label">Bank Account</label>
                                        <div>
                                            <input
                                                ref={(f) => {
                                                    this.connectBankAccount_companyBankAccount = f;
                                                }}
                                                autoComplete="off"
                                                type="text"
                                                className={notValidClasses.connectBankAccount_companyBankAccountCls}
                                                required
                                                defaultValue={this.state.connectBankAccount_companyBankAccount}
                                                onBlur={this.validationCheck}
                                            />
                                            <div className={notValidClasses.connectBankAccount_companyBankAccountValGrpCls}>
                                                {this.state.connectBankAccount_companyBankAccountValMsg}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
